/* unplugin-vue-components disabled */import script from "./BatchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchPage.vue?vue&type=script&setup=true&lang=js"

import "./BatchPage.vue?vue&type=style&index=0&id=f891bc5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f891bc5c"]])

export default __exports__